import React from 'react';
import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
const logo = '/img/Logo_irissar.jpg';

interface HeaderProps {
  onUserClick?: () => void;
}

const Header: React.FC<HeaderProps> = () => {
  const navigate = useNavigate();

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        backgroundColor: '#e0e0e0',
        boxShadow: 'none',
        borderBottom: '1px solid #999',
        height: '64px'
      }}
    >
      <Toolbar sx={{ 
        justifyContent: 'space-between', 
        px: 0,
        height: '64px',
        minHeight: '64px !important',
        alignItems: 'center',
      }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '40px',
          }}
        >
          <img
            src={logo}
            alt="IRISSAR Logo"
            style={{
              height: '40px',
              width: 'auto',
              display: 'block',
            }}
          />
        </Box>

        {/* Desktop Menu */}
        <Box sx={{ 
          display: 'flex',
          alignItems: 'center',
          gap: 0,
          '@media (max-width: 768px)': {
            display: 'none'
          }
        }}>
          {['PRODUCTS', 'ABOUT', 'CONTACT'].map((text, index) => (
            <React.Fragment key={text}>
              <Box sx={{ position: 'relative' }}>
                <Button
                  variant="text"
                  sx={{
                    color: '#000',
                    fontSize: '0.9rem',
                    letterSpacing: '4px',
                    fontWeight: 500,
                    fontFamily: 'sans-serif',
                    px: '8px',
                    textDecoration: 'none',
                    position: 'relative',
                    '&:hover': {
                      backgroundColor: 'transparent',
                      opacity: 0.7
                    },
                    mx: '10px'
                  }}
                >
                  {text}
                </Button>
              </Box>
            </React.Fragment>
          ))}
          <Box sx={{ width: '1px', height: '40px', bgcolor: '#999', mx: 2 }} />
          <Button
            variant="text"
            component="a"
            href="https://login.irissar.com"
            sx={{
              color: '#000',
              fontSize: '0.9rem',
              letterSpacing: '4px',
              fontWeight: 500,
              fontFamily: 'sans-serif',
              px: '8px',
              textDecoration: 'none',
              '&:hover': {
                backgroundColor: 'transparent',
                opacity: 0.7
              },
              marginLeft: '10px',
              marginRight: '-5px'
            }}
          >
            USER
          </Button>
        </Box>

        {/* Mobile Menu Button */}
        <Button
          variant="text"
          component="a"
          href="https://login.irissar.com"
          sx={{
            display: { 
              xs: 'block', 
              md: 'none' 
            },
            color: '#000',
            fontSize: '0.875rem',
            letterSpacing: '2px',
            fontWeight: 500,
            fontFamily: '"Helvetica Neue", sans-serif',
            px: '15px',
            minWidth: 'auto',
            marginRight: 200,
            '&:hover': {
              backgroundColor: 'transparent',
              opacity: 0.7
            }
          }}
        >
          MENU
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Header; 